import React from 'react';
import {filter} from 'lodash';

export default function ({skills_level_data}) {
    return (
        <div className="ssp-tier ssp-section">
            <div className="flex-column flex-gap-15">
                <OneTier
                    tier={`bronze`}
                    skills_level_data={skills_level_data}
                />
                <OneTier
                    tier={`silver`}
                    skills_level_data={skills_level_data}
                />
                <OneTier
                    tier={`gold`}
                    skills_level_data={skills_level_data}
                />
                <OneTier
                    tier={`master`}
                    skills_level_data={skills_level_data}
                />
            </div>
        </div>
    );
}

function OneTier ({tier, skills_level_data}) {
    const n = filter(skills_level_data, {tier}).length;
    const bar_width = Math.round(n / 13 * 100);
    const icon_url = process.env.PUBLIC_S3_ASSETS_URL
        + `/skills-passport/tier-icon/`
        + `${tier}.png`;

    return (
        <div className="ssp-tier-onetier">
            <div className="flex-row flex-gap-10">
                <div className={`ssp-tier-onetier-icon border-${tier} box-shadow-${tier} flex-row flex-vh-center`}>
                    <img src={icon_url} />
                </div>
                <div className="flex-1">
                    <div className="flex-row flex-between">
                        <span className="ssp-tier-onetier-name">{tier}</span>
                        <span>{n} {`skill`}{n > 1 ? 's' : ''}</span>
                    </div>
                    <div className="ssp-tier-onetier-bar">
                        <div className={`ssp-tier-onetier-bar-solid background-${tier}`} style={{width: `${bar_width}%`}}>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}